import { useState, useEffect } from "react";
import { cartImageOne } from "src/assets/images";
import { Trash2 } from "lucide-react"; // Bin icon from Lucide React
import { useProtectedRoutesContext } from "src/context/ProtectedRoutes";
import { renderCurrency } from "../renderCurrency";

const CartModal = () => {
    const { conversionRates } = useProtectedRoutesContext()
    const [cart, setCart] = useState([]);

    useEffect(() => {
        // Fetch cart items from localStorage
        const storedCart = JSON.parse(localStorage.getItem("cart")) || [];
        setCart(storedCart);
    }, []);

    const removeFromCart = (id) => {
        const updatedCart = cart.filter((item) => item.id !== id);
        setCart(updatedCart);
        localStorage.setItem("cart", JSON.stringify(updatedCart));
    };

    const updateQuantity = (id, newQuantity) => {
        if (newQuantity < 1) return;

        const updatedCart = cart.map((item) =>
            item.id === id ? { ...item, quantity: newQuantity } : item
        );

        setCart(updatedCart);
        localStorage.setItem("cart", JSON.stringify(updatedCart));
    };

    return (
        <div>
            {cart?.length === 0 ? (
                <p className="text-center text-gray-500">Your cart is empty</p>
            ) : (
                cart.map((item) => (
                    <div key={item.id} className="grid grid-cols-1 lg:grid-cols-2 gap-4 border-b pb-4 mb-4 relative">
                        {/* Left Column - Image */}
                        <div className="justify-center">
                            <img
                                src={item.itemImages?.length > 0 ? item.itemImages[0].url : cartImageOne}
                                alt={item.design_number || "Fabric"}
                                className="w-full max-w-[300px]"
                            />
                        </div>

                        {/* Right Column - Text */}
                        <div className="text-left">
                            <h6 className="text-lg font-semibold amount-name">
                                {item.design_number || "No Design Number"}
                            </h6>
                            <h6 className="text-lg font-semibold amount-figure">
                                {renderCurrency(item.grade?.price * conversionRates[item.materialId])}
                            </h6>
                            <h6 className="text-lg font-semibold amount-figure">
                                Material: {item.material?.name || "Unknown"}
                            </h6>

                            {/* Quantity Input */}
                            <div className="fatix-blueprint-value">
                                <input
                                    type="number"
                                    value={item.quantity}
                                    min="1"
                                    className="w-full text-center text-lg font-medium border-x border-gray-300"
                                    onChange={(e) => {
                                        const value = parseInt(e.target.value, 10);
                                        if (!isNaN(value) && value > 0) {
                                            updateQuantity(item.id, value);
                                        }
                                    }}
                                />
                            </div>

                            {/* Update Quantity Button (Optional) */}
                            <button
                                className="fatix-blueprint-value-btn mt-2 bg-blue-500 text-white px-4 py-1 rounded-md hover:bg-blue-700"
                                onClick={() => updateQuantity(item.id, item.quantity)}
                            >
                                Update Quantity
                            </button>
                        </div>

                        {/* Bin Icon to Remove Item */}
                        <button
                            className="absolute top-2 right-2 text-blue-500 hover:text-blue-700"
                            onClick={() => removeFromCart(item.id)}
                        >
                            <Trash2 className="w-5 h-5" />
                        </button>
                    </div>
                ))
            )}

            <div className="checkout-value-div">
                {cart?.length === 0 ? (
                    <a href="/shop" className="" disabled>Go to Shop</a>
                ) : (
                    <a href="/checkout">Checkout</a>
                )}
            </div>
        </div>
    );
};

export default CartModal;
